import { render, staticRenderFns } from "./ContactLensCreate.vue?vue&type=template&id=5c78a645&"
import script from "./ContactLensCreate.vue?vue&type=script&lang=js&"
export * from "./ContactLensCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports